import { Check } from "lucide-react";

type Etapa = { titulo: string; apoio: string };

/**
 * Barra de etapas da cotação.
 *
 * A antiga era uma linha de 1px com três círculos posicionados em `absolute`
 * por cima, sem rótulo nenhum: a pessoa via "1 2 3" e não sabia o que cada
 * número continha. Aqui cada etapa diz o que é, a concluída vira check e a
 * atual fica em destaque.
 */
const BarraEtapas = ({ etapas, atual }: { etapas: Etapa[]; atual: number }) => (
  <ol className="flex gap-6 border-b border-slate-100 px-6 pb-3 pt-1">
    {etapas.map((etapa, i) => {
      const concluida = i < atual;
      const ativa = i === atual;

      return (
        <li key={etapa.titulo} className="flex min-w-0 flex-1 flex-col gap-2">
          <span
            className={`h-0.5 w-full rounded-full ${
              concluida || ativa ? "bg-brand-sidebar" : "bg-slate-200"
            }`}
          />
          <span className="flex min-w-0 items-center gap-2">
            <span
              className={`grid h-5 w-5 shrink-0 place-items-center rounded-full text-[10px] font-bold ${
                concluida
                  ? "bg-emerald-500 text-white"
                  : ativa
                    ? "bg-brand-sidebar text-white"
                    : "bg-slate-200 text-slate-500"
              }`}
            >
              {concluida ? <Check className="h-3 w-3" strokeWidth={3} /> : i + 1}
            </span>
            <span className="min-w-0">
              <span
                className={`block truncate text-xs ${
                  ativa || concluida ? "font-semibold text-slate-900" : "text-slate-500"
                }`}
              >
                {etapa.titulo}
              </span>
              <span className="block truncate text-[10px] text-slate-400">
                {etapa.apoio}
              </span>
            </span>
          </span>
        </li>
      );
    })}
  </ol>
);

export default BarraEtapas;
